export { default as Battery } from './battery';
export { default as BatteryLow } from './battery-low';
export { default as DeviceLandscape } from './device-landscape';
export { default as DevicePortrait } from './device-portrait';
export { default as Location } from './location';
export { default as Resolution4K } from './resolution-4k';
export { default as ResolutionHd } from './resolution-hd';
export { default as ResolutionSd } from './resolution-sd';
export { default as Streaming } from './streaming';
export { default as Sync } from './sync';
export { default as WiFi } from './wifi';
export { default as WiFiWarning } from './wifi-warning';



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/index.js